/**
 * フォーム関係-解約申請確認用-項目の値を表示するコンポーネント
 */
import React, { useEffect, useState } from "react";

import { TFormObject } from "../../../common/components/types";

import { jsonParseSafety } from "../../../../utils/formData";
import { separateWithComma } from "../../../../utils/string";

import ShowFile from "../../../common/components/atoms/ShowFile";

type Props = {
  terminateFormRowObj: TFormObject;
};

const ShowFormValueForTerminateDeal: React.FC<Props> = (props: Props) => {
  const { terminateFormRowObj } = props;

  const [row, setRow] = useState(terminateFormRowObj);

  useEffect(() => {
    setRow(terminateFormRowObj);
  }, [terminateFormRowObj]);

  if (!row) return null;

  return (
    <>
      {(row.json.formType === "text" || row.json.formType === "date") &&
        row.content}
      {row.json.formType === "number" && separateWithComma(row.content)}
      {(row.json.formType === "radio" ||
        row.json.formType === "select" ||
        row.json.formType === "search-select" ||
        // TODO: 今回 checkbox は対応見送りになっている。使う場合は調整が必要
        row.json.formType === "checkbox") &&
      row.content !== ""
        ? Object.values(jsonParseSafety(row.content))[0]
        : ""}
      {row.json.formType === "textArea" && (
        <>
          {row.content.split("\n").map((line: string) => (
            <span key={line}>
              {line}
              <br />
            </span>
          ))}
        </>
      )}
      {row.json.formType === "file" && (
        <ShowFile
          formGroupName={row.json.formGroupName}
          formContent={row.content}
        />
      )}
    </>
  );
};

export default ShowFormValueForTerminateDeal;
